
export const GET_MAINTENANCE_STATUS:string = 'GET_MAINTENANCE_STATUS';
export const SET_MAINTENANCE_STATUS:string = 'SET_MAINTENANCE_STATUS';
export const SET_NEW_MAINTENANCE:string = 'SET_NEW_MAINTENANCE';
export const MAINTENANCE_STATUS_SEEN:string = 'MAINTENANCE_STATUS_SEEN';

export const APP_INITIALIZED:string = 'APP_INITIALIZED';